var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcPhoneCallWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M13.488 15.243c1.251 2.198 3.071 4.018 5.27 5.269l1.178-1.65c.392-.55 1.133-.72 1.725-.395 1.886 1.03 3.969 1.65 6.111 1.818.693.055 1.228.634 1.228 1.33v5.949c0 .684-.517 1.257-1.197 1.327-.707.073-1.419.109-2.136.109C14.253 29 5 19.747 5 8.333c0-.717.036-1.429.11-2.136C5.18 5.517 5.751 5 6.435 5h5.95c.695 0 1.274.535 1.329 1.228.168 2.142.788 4.225 1.818 6.11.324.593.155 1.334-.394 1.726l-1.651 1.179zm-3.363-.876l2.534-1.81c-.72-1.552-1.212-3.199-1.463-4.89H7.68c-.008.221-.012.444-.012.666-.001 9.942 8.057 18 17.999 18 .222 0 .445-.004.666-.013v-3.516c-1.691-.251-3.338-.744-4.89-1.463l-1.81 2.534c-.728-.283-1.436-.618-2.117-1l-.077-.044c-2.616-1.489-4.781-3.654-6.27-6.27l-.044-.077c-.382-.681-.717-1.389-1-2.117z",
    transform: "translate(-349 -1202) translate(24 464) translate(241 724) translate(70) rotate(135 21.1 26.9)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPhoneCallWhite);
export default __webpack_public_path__ + "static/media/ic-phone-call-white.44787581.svg";
export { ForwardRef as ReactComponent };